import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import CropPDFImagesListScreen from "./CropPDFImagesListScreen";
import { BASE_URL } from "../Config";

function CropPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Crop PDF Files" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/crop_pdf", title: "Crop PDF Online" },
    data2: { link: "/crop_pdf", title: "PDF Cropper" },
    data3: { link: "/crop_pdf", title: "Trim PDF Files" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Crop PDF online easily. Trim PDF pages, remove unwanted areas, and edit documents quickly with our fast, secure, and easy PDF crop tool."
      ></meta>
      <meta
        name="keywords"
        content="crop PDF, crop PDF online, trim PDF pages, PDF page cropper, PDF editor online, edit PDF pages, remove PDF margins, PDF page editor, online PDF crop tool, adjust PDF pages, PDF management tool, crop PDF documents, PDF trimming tool, crop PDF fast, resize PDF pages, pdf cropper"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <CropPDFImagesListScreen title={title}></CropPDFImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Crop PDF website provides a fast, secure, and efficient way to trim and adjust PDF pages without requiring an internet connection. Designed to work fully offline, this powerful tool allows users to remove unwanted margins, borders, or white spaces while keeping the original content intact. Whether you are editing scanned documents, preparing files for printing, or optimizing PDFs for sharing, this offline-ready solution helps you achieve precise results effortlessly. Users can crop PDF online when needed or process files completely offline for maximum privacy and security. With an intuitive interface, this advanced PDF cropper makes it easy to select specific areas, apply consistent cropping across multiple pages, and preview changes in real time. The platform also functions as a reliable PDF trimmer online, enabling users to resize pages accurately without affecting text clarity or image quality. Ideal for students, professionals, and businesses, this tool preserves document layout while reducing file size and improving visual presentation. If you are looking for a dependable crop PDF online, a user-friendly PDF cropper, or a secure PDF trimmer online with offline support, this website delivers a smooth and modern document workflows." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Crop",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Crop PDF Tool"
            why_use={[
              {
                title: "Remove Unwanted Margins and White Space",
                description:
                  "Our crop PDF tool helps remove extra margins and blank spaces, making PDF documents cleaner and more professional.",
              },
              {
                title: "Improve Document Appearance",
                description:
                  "Using crop PDF online enhances visual presentation by focusing only on important content.",
              },
              {
                title: "Optimize PDFs for Printing",
                description:
                  "This PDF cropper ensures proper page alignment and prevents important content from being cut off during printing.",
              },
              {
                title: "Reduce PDF File Size",
                description:
                  "Cropping unused areas helps reduce file size. A PDF trimmer online optimizes PDFs for easy sharing and storage.",
              },
              {
                title: "Perfect for Scanned Documents",
                description:
                  "Scanned PDFs often have uneven borders. A crop PDF tool corrects alignment issues and improves readability.",
              },
              {
                title: "Preserve Original Content Quality",
                description:
                  "Modern PDF cropper tools maintain text clarity and image quality while trimming pages accurately.",
              },
              {
                title: "Batch Crop Multiple Pages",
                description:
                  "With crop PDF online, users can apply the same crop settings across multiple pages at once.",
              },
              {
                title: "Offline Processing for Privacy",
                description:
                  "This offline crop PDF tool processes files locally, keeping sensitive documents secure.",
              },
              {
                title: "Save Time with Automated Cropping",
                description:
                  "Our PDF trimmer online automates the cropping process, saving time compared to manual editing.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app-bundle/id${1863317370}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default CropPDFMain;
